<wl-busy [show]="isLoading"></wl-busy>

<!-- Shared node card template — each named pTemplate delegates here via ngTemplateOutlet. -->
<!-- PrimeNG 20 Tree.getTemplateForNode() does:                                             -->
<!--   node.type ? templateMap[node.type] : templateMap['default']                          -->
<!-- so a 'default' template is never reached when node.type is set.  Four named templates  -->
<!-- are required to ensure every node level renders the card.                              -->
<ng-template #nodeCard let-node>
  <div
    class="gateway-node-card"
    [pTooltip]="node.data?.tooltip"
    tooltipPosition="top"
    (click)="onNodeClick(node)"
  >
    <wl-card>
      <atlas-header>
        <span class="{{ node.icon }} mr-8"></span>{{ node.label }}
      </atlas-header>

      <div [ngSwitch]="node.type">

        <!-- Revenue item -->
        <ng-container *ngSwitchCase="'revenue-item'">
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.item-num' | translate }}</span>
            <span>{{ node.data?.id }}</span>
          </div>
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.accounting-package-id' | translate }}</span>
            <span>{{ node.data?.accountingPackageId }}</span>
          </div>
        </ng-container>

        <!-- Accounting package -->
        <ng-container *ngSwitchCase="'accounting-package'">
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.id' | translate }}</span>
            <span>{{ node.data?.id }}</span>
          </div>
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.payment-type-id' | translate }}</span>
            <span>{{ node.data?.paymentTypeId }}</span>
          </div>
        </ng-container>

        <!-- Payment type -->
        <ng-container *ngSwitchCase="'payment-type'">
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.id' | translate }}</span>
            <span>{{ node.data?.id }}</span>
          </div>
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span
              *ngIf="node.data?.isCC"
              class="pi pi-check-circle"
              [title]="'revenue.gateway-resolution-tree.credit-card' | translate"
            ></span>
            <span
              *ngIf="node.data?.isACH"
              class="pi pi-money-bill"
              [title]="'revenue.gateway-resolution-tree.ach' | translate"
            ></span>
          </div>
        </ng-container>

        <!-- Gateway -->
        <ng-container *ngSwitchCase="'gateway'">
          <div class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-type' | translate }}</span>
            <span>{{ node.data?.gatewayTypeName || node.data?.gatewayTypeId || '—' }}</span>
          </div>
          <div *ngIf="node.data?.isSandbox" class="flx-layout-row flx-align-start-center flx-gap-8px">
            <span class="light-text">{{ 'revenue.gateway-resolution-tree.sandbox' | translate }}</span>
          </div>
        </ng-container>

      </div>
    </wl-card>
  </div>
</ng-template>

<wl-notification-banner
  *ngIf="loadError"
  class="mb-20"
  [translationKey]="'revenue.gateway-resolution-tree.load-error'"
></wl-notification-banner>

<p-tree *ngIf="!loadError" [value]="treeNodes">
  <ng-template let-node pTemplate="revenue-item">
    <ng-container *ngTemplateOutlet="nodeCard; context: { $implicit: node }"></ng-container>
  </ng-template>

  <ng-template let-node pTemplate="accounting-package">
    <ng-container *ngTemplateOutlet="nodeCard; context: { $implicit: node }"></ng-container>
  </ng-template>

  <ng-template let-node pTemplate="payment-type">
    <ng-container *ngTemplateOutlet="nodeCard; context: { $implicit: node }"></ng-container>
  </ng-template>

  <ng-template let-node pTemplate="gateway">
    <ng-container *ngTemplateOutlet="nodeCard; context: { $implicit: node }"></ng-container>
  </ng-template>
</p-tree>

<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top"
  [(visible)]="showDialog"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <h4>
      <span class="{{ selectedNode?.icon }} mr-8"></span>
      {{ selectedNode?.label }}
    </h4>
  </ng-template>

  <div class="atlas-form flx-layout-column flx-gap-27px" *ngIf="selectedNode">
    <ng-container [ngSwitch]="selectedNode.type">

      <!-- Revenue Item -->
      <ng-container *ngSwitchCase="'revenue-item'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.item-num' | translate }}</label><div>{{ selectedNode.data.id }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.accounting-package-id' | translate }}</label><div>{{ selectedNode.data.accountingPackageId }}</div></div>
        </div>
        <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.description' | translate }}</label><div>{{ selectedNode.data.description }}</div></div>
      </ng-container>

      <!-- Accounting Package -->
      <ng-container *ngSwitchCase="'accounting-package'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.package-id' | translate }}</label><div>{{ selectedNode.data.id }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.payment-type-id' | translate }}</label><div>{{ selectedNode.data.paymentTypeId }}</div></div>
        </div>
        <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.name' | translate }}</label><div>{{ selectedNode.data.name }}</div></div>
      </ng-container>

      <!-- Payment Type -->
      <ng-container *ngSwitchCase="'payment-type'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.payment-type-id' | translate }}</label><div>{{ selectedNode.data.paymentTypeId }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-id' | translate }}</label><div>{{ selectedNode.data.ccGatewayId }}</div></div>
        </div>
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.credit-card' | translate }}</label><div>{{ selectedNode.data.isCC == null ? '—' : (selectedNode.data.isCC ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.ach' | translate }}</label><div>{{ selectedNode.data.isACH == null ? '—' : (selectedNode.data.isACH ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
        </div>
        <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.name' | translate }}</label><div>{{ selectedNode.data.paymentType || '—' }}</div></div>
      </ng-container>

      <!-- CC Gateway -->
      <ng-container *ngSwitchCase="'gateway'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-id' | translate }}</label><div>{{ selectedNode.data.id }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-type' | translate }}</label><div>{{ selectedNode.data.gatewayTypeName || '—' }}</div></div>
        </div>
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.sandbox' | translate }}</label><div>{{ selectedNode.data.isSandbox == null ? '—' : (selectedNode.data.isSandbox ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.momentive-payments-echeck' | translate }}</label><div>{{ selectedNode.data.precznECheck == null ? '—' : (selectedNode.data.precznECheck ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
        </div>
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.momentive-payments-merchant-id' | translate }}</label><div>{{ selectedNode.data.precznMerchantId || '—' }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.cardpointe-merchant-id' | translate }}</label><div>{{ selectedNode.data.cardConnectMerchId || '—' }}</div></div>
        </div>
      </ng-container>

    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="flx-layout-row flx-wrap-nowrap flx-align-end-center">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="closeDialog()">
        CLOSE
      </button>
    </div>
  </ng-template>
</p-dialog>
